import { useState, useEffect } from "react";
import { Typography, Row, Col, Input, Select, InputNumber, Alert } from "antd";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const EditMeetingRoom = ({ id }) => {
  const navigate = useNavigate();
  const { MainResponse } = useSelector((state) => state);

  const [oldMeetingRoomName, setOldMeetingRoomName] = useState("");
  const [meetingRoomName, setMeetingRoomName] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [meetingRoomSize, setMeetingRoomSize] = useState();
  const [meetingRoomEmail, setMeetingRoomEmail] = useState("");
  const [password, setPassword] = useState("");
  const [repeatPassword, setRepeatPassword] = useState("");

  const [showAlert, setShowAlert] = useState(false);
  const [showPassworAlert, setShowPasswordAlert] = useState(false);
  const [showPasswordLengthAlert, setShowPasswordLengthAlert] = useState(false);
  const [showAlertAvailableEmail, setShowAlertAvailableEmail] = useState(false);
  const [showAlertIncorrectEmail, setShowAlertIncorrectEmail] = useState(false);
  const [buttonDisable, setButtonDisable] = useState(false);

  useEffect(() => {
    getAMeetingRoom();
  }, []);

  const getAMeetingRoom = async () => {
    let result = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/get-meetingroom/${id}`,
      {
        headers: {
          authorization: `bearer ${JSON.parse(localStorage.getItem("token"))} `,
        },
      }
    );
    result = await result.json();
    setOldMeetingRoomName(result.meetingRoomName);
    setMeetingRoomName(result.meetingRoomName);
    setCompanyName(result.companyName);
    setMeetingRoomSize(result.meetingRoomSize);
    setMeetingRoomEmail(result.meetingRoomEmail);
  };

  const handleChangeCompany = (value) => {
    setCompanyName(value);
  };

  const isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const prepareToUpdate = () => {
    if (isValidEmail(meetingRoomEmail)) {
      if (password.length > 0) {
        if (
          oldMeetingRoomName &&
          meetingRoomName &&
          companyName &&
          meetingRoomSize &&
          typeof meetingRoomSize !== "String"
        ) {
          checkPasswordLength();
          setShowAlert(false);
        } else {
          setShowAlert(true);
        }
      } else {
        updateEmployeeWithoutPassword();
      }
    } else {
      setShowAlertIncorrectEmail(true);
    }
  };

  const checkPasswordLength = () => {
    if (password.length > 5) {
      setShowPasswordLengthAlert(false);
      updateMeetingRoom();
    } else {
      setShowPasswordLengthAlert(true);
    }
  };

  const updateMeetingRoom = async () => {
    if (password === repeatPassword) {
      setButtonDisable(true);

      let result = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/meetingroom-update/${id}`,
        {
          method: "put",
          body: JSON.stringify({
            meetingRoomName,
            companyName,
            meetingRoomSize,
            meetingRoomEmail,
            password,
          }),
          headers: {
            "Content-Type": "application/json",
            authorization: `bearer ${JSON.parse(
              localStorage.getItem("token")
            )} `,
          },
        }
      );
      result = await result.json();
      if (result) {
        navigate(-1);
        setButtonDisable(false);
      }
    } else {
      setShowPasswordAlert(true);
    }
  };

  const updateEmployeeWithoutPassword = async () => {
    if (
      oldMeetingRoomName &&
      meetingRoomName &&
      companyName &&
      meetingRoomSize &&
      typeof meetingRoomSize !== "String"
    ) {
      setButtonDisable(true);

      let result = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/meetingroom-update/${id}`,
        {
          method: "put",
          body: JSON.stringify({
            meetingRoomName,
            companyName,
            meetingRoomSize,
            meetingRoomEmail,
          }),
          headers: {
            "Content-Type": "application/json",
            authorization: `bearer ${JSON.parse(
              localStorage.getItem("token")
            )} `,
          },
        }
      );
      result = await result.json();
      if (result) {
        navigate(-1);
        setButtonDisable(false);
      }
    } else {
      setShowAlert(true);
    }
  };

  return (
    <>
      {showAlert && (
        <Alert
          onClose={() => setShowAlert(false)}
          message="Diqqət!"
          description="Zəhmət olmasa boş sahələri doldurun!"
          type="warning"
          showIcon
          closable
        />
      )}
      {showPassworAlert && (
        <Alert
          onClose={() => setShowAlert(false)}
          message="Diqqət!"
          description="Şifrələriniz eyni deyil!"
          type="warning"
          showIcon
          closable
        />
      )}
      {showPasswordLengthAlert && (
        <Alert
          onClose={() => setShowAlert(false)}
          message="Diqqət!"
          description="Şifrə 5 simvoldan çox olmalıdır!"
          type="warning"
          showIcon
          closable
        />
      )}
      {showAlertAvailableEmail && (
        <Alert
          onClose={() => setShowAlertAvailableEmail(false)}
          message="Diqqət!"
          description="Bu e-poçt hesabı artıq qeydiyyatdan keçirilib!"
          type="warning"
          showIcon
          closable
        />
      )}
      {showAlertIncorrectEmail && (
        <Alert
          onClose={() => setShowAlertIncorrectEmail(false)}
          message="Diqqət!"
          description="E-poçt hesabında səhv var!"
          type="warning"
          showIcon
          closable
        />
      )}

      <Row className="add-row">
        <Col span={6}>
          <Typography.Text className="add-title">Otağın adı</Typography.Text>
          <Input
            className="add-input"
            size="large"
            value={meetingRoomName}
            onChange={(e) => setMeetingRoomName(e.target.value)}
          />
        </Col>
        <Col span={6}>
          <Typography.Text className="add-title">Şirkət</Typography.Text>

          <Select
            size="large"
            value={companyName}
            onChange={handleChangeCompany}
            className="add-dropdown"
            options={MainResponse.allCompanyNames}
          />
        </Col>

        <Col span={6}>
          <Typography.Text className="add-title">Otağın tutumu</Typography.Text>

          <InputNumber
            className="add-input"
            size="large"
            onChange={(value) => setMeetingRoomSize(value)}
            value={meetingRoomSize}
            min={1}
            max={700}
          />
        </Col>
        <Col span={6}>
          <Typography.Text className="add-title">E-poçt</Typography.Text>
          <Input
            className="add-input"
            size="large"
            value={meetingRoomEmail}
            onChange={(e) =>
              setMeetingRoomEmail(e.target.value.toLowerCase().trim())
            }
          />
        </Col>
      </Row>

      <Row className="add-row">
        <Col span={8}>
          <Typography.Text className="add-title">
            Otaq cihazının şifrəsi
          </Typography.Text>
          <Input.Password
            className="add-input"
            size="large"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            type="password"
          />
        </Col>

        <Col span={8}>
          <Typography.Text className="add-title">
            Şifrənin təkrarı
          </Typography.Text>
          <Input.Password
            className="add-input"
            size="large"
            value={repeatPassword}
            onChange={(e) => setRepeatPassword(e.target.value)}
            type="password"
          />
        </Col>

        <Col span={4}>
          <button
            disabled={buttonDisable}
            className="success-button"
            onClick={prepareToUpdate}
          >
            Təsdiq Et
          </button>
        </Col>
        <Col span={4}>
          <button
            className="cancel-button"
            onClick={() => {
              navigate(-1);
            }}
          >
            İmtina Et
          </button>
        </Col>
      </Row>
    </>
  );
};

export default EditMeetingRoom;
